import { Sun, Moon } from "@phosphor-icons/react";
import { useTheme } from "../contexts/ThemeContext";

/**
 * Compact day/night switcher. Icon flips + rotates on change.
 */
export default function ThemeToggle({ size = "md" }) {
  const { isDark, toggle } = useTheme();

  const dims = size === "sm" ? "w-8 h-8" : "w-10 h-10";
  const iconSize = size === "sm" ? 14 : 16;

  return (
    <button
      data-testid="theme-toggle"
      onClick={toggle}
      title={isDark ? "Cambiar a modo día" : "Cambiar a modo noche"}
      aria-label={isDark ? "Modo día" : "Modo noche"}
      className={`${dims} flex items-center justify-center rounded-xl bg-white/5 hover:bg-white/10 border border-white/10 text-white/70 hover:text-white transition group relative overflow-hidden`}
    >
      <span
        key={isDark ? "moon" : "sun"}
        className="theme-flip inline-flex"
      >
        {isDark ? (
          <Moon size={iconSize} weight="fill" style={{ color: "#FACC15" }} />
        ) : (
          <Sun size={iconSize} weight="fill" style={{ color: "#F59E0B" }} />
        )}
      </span>
    </button>
  );
}
